const routes = [
  {
    resource: "campaign",
    icon: "Megaphone",
    name: "Campaigns",
    path: "campaign",
  },
  {
    resource: "operator",
    icon: "Key",
    name: "Operators",
    path: "operator",
  },
  {
    resource: "company",
    icon: "BuildingLibrary",
    name: "Companies",
    path: "company",
  },
  {
    resource: "pos",
    icon: "ShoppingCart",
    name: "POS Management",
    path: "pos",
    // routes: [
    //   {
    //     icon: "Identification",
    //     path: "billing/payment-profile",
    //     name: "Payment Profile",
    //   },
    //   {
    //     icon: "ClipboardDocumentCheck",
    //     path: "billing/invoices",
    //     name: "Invoices",
    //   },
    // ],
  },
  {
    resource: "member",
    icon: "UserGroup",
    name: "Member",
    path: "member",
  },

  {
    resource: "acceptance-point",
    icon: "ViewfinderCircle",
    name: "Acceptance Points",
    path: "acceptance-point",
    // routes: [
    //   {
    //     icon: "Inbox",
    //     path: "vending/tagged",
    //     name: "Tagged",
    //   },
    //   {
    //     icon: "InboxStack",
    //     path: "vending/untagged",
    //     name: "Untagged",
    //   },
    // ],
  },
  // {
  //   resource: "billing",
  //   icon: "Banknotes",
  //   name: "Billing",
  //   path: "billing",
  //   routes: [
  //     {
  //       icon: "Identification",
  //       path: "billing/payment-profile",
  //       name: "Payment Profile",
  //     },
  //     {
  //       icon: "ClipboardDocumentCheck",
  //       path: "billing/invoices",
  //       name: "Invoices",
  //     },
  //   ],
  // },
  {
    resource: "transaction",
    icon: "CurrencyDollar",
    name: "Transactions",
    path: "transaction",
  },
  // {
  //   resource: "transaction",
  //   icon: "ArrowDownTray",
  //   name: "Report",
  //   path: "report",
  //   routes: [
  //     {
  //       icon: "Inbox",
  //       path: "report/daily",
  //       name: "Daily",
  //     },
  //     {
  //       icon: "InboxStack",
  //       path: "report/monthly",
  //       name: "Monthly",
  //     },
  //   ],
  // },
  {
    resource: "user",
    icon: "FingerPrint",
    name: "User Management",
    path: "user",
  },
];

export default routes;
